import { render, staticRenderFns } from "./CurrentTemperatures.vue?vue&type=template&id=14ef060c&scoped=true&"
import script from "./CurrentTemperatures.vue?vue&type=script&lang=js&"
export * from "./CurrentTemperatures.vue?vue&type=script&lang=js&"
import style0 from "./CurrentTemperatures.vue?vue&type=style&index=0&id=14ef060c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ef060c",
  null
  
)

export default component.exports